/*
 * inselvolt Kompatibilitätsberater — UI-Zustand und Übergänge (reine Logik).
 *
 * Herausgelöst aus app/berater-ui.js (E6, 2026-08-25): Das Zustandsobjekt der
 * Beraterseite und seine Übergangsfunktionen samt Folge-Resets lagen verstreut
 * in ~60 Closures von start() und waren für keinen Test erreichbar.
 *
 * Die Übergänge verändern das übergebene Zustandsobjekt IN PLACE und geben es
 * (bzw. einen Erfolgswert) zurück — die UI-Closures halten dieselbe Referenz.
 * Kein Observer-Apparat: Das explizite Neuzeichnen bleibt Sache der UI.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.IVBeraterZustand = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  /* Startzustand. `filter` kommt vom Filterwerk (eine Quelle des leeren
   * Filters); hereingereicht, damit dieses Modul keine Ladereihenfolge
   * voraussetzt. */
  function neuerZustand(leererFilter) {
    return {
      aufgabe: 'speicher_finden',
      wrHersteller: null, wrFamilie: null, wrVariante: null,
      spHersteller: null, spFamilie: null, spGroesse: null,
      auswahlOffen: true,
      filter: leererFilter,
      sortierung: 'empfehlung',
      // Welche Baureihen aufgeklappt sind. Beim ersten Zeichnen wird die
      // oberste geöffnet — man sieht sofort, wie eine Gruppe aussieht, ohne
      // dass neun aufgeklappte Tabellen die Seite fluten.
      offeneGruppen: {},
      gruppenInitialisiert: false,
      filterOffen: false,
      // Ob der Auswahlfeld-Rückfall unter dem Suchfeld aufgeklappt ist, je Typ.
      rueckfallOffen: {},
      /*
       * Ab welcher Gruppe der zweite Block beginnt (Baureihen ohne Shop-Artikel).
       * Wird beim Gruppieren gesetzt und beim Zeichnen für die Trennüberschrift
       * gelesen — 0 heißt: kein erster Block, also auch keine Überschrift.
       */
      trennerAb: 0,
      vergleich: [],
    };
  }

  /*
   * Aufgabenwechsel. false = nichts zu tun (dieselbe Aufgabe). Beim Wechsel
   * in die Erweiterung wird der Wechselrichter bewusst geleert: Was in einer
   * anderen Aufgabe gewählt war, ist hier eine Behauptung über die Anlage des
   * Kunden — die trifft er selbst.
   */
  function wechsleAufgabe(zustand, aufgabeId) {
    if (zustand.aufgabe === aufgabeId) return false;
    zustand.aufgabe = aufgabeId;
    zustand.vergleich = [];
    zustand.auswahlOffen = true;
    zustand.filter.hersteller = [];
    if (aufgabeId === 'erweitern') {
      zustand.wrHersteller = null; zustand.wrFamilie = null; zustand.wrVariante = null;
    }
    return true;
  }

  /*
   * Auswahl aufklappen. false = war schon offen, es gibt nichts neu zu zeichnen.
   *
   * Gebraucht wird das für den Klick auf den BEREITS AKTIVEN Reiter. Der galt
   * lange als „nichts zu tun" und war damit ein toter Klick — im August 2026
   * der mit Abstand häufigste auf der Seite (18 von 59, mobil 10 von 26). Wer
   * den Reiter anklickt, auf dem er ohnehin steht, meint nicht „wechseln",
   * sondern „hier geht es los".
   */
  function oeffneAuswahl(zustand) {
    if (zustand.auswahlOffen) return false;
    zustand.auswahlOffen = true;
    return true;
  }

  /* Suchtreffer WR: setzt denselben Zustand wie die drei Auswahlfelder.
   * false, wenn die Varianten-ID nicht existiert — dann bleibt alles stehen. */
  function setzeWrTreffer(zustand, daten, variantenId) {
    var getroffen = false;
    (daten.wechselrichter || []).forEach(function (f) {
      (f.varianten || []).forEach(function (v) {
        if (v.id !== variantenId) return;
        zustand.wrHersteller = f.hersteller;
        zustand.wrFamilie = f.id;
        zustand.wrVariante = v.id;
        getroffen = true;
      });
    });
    return getroffen;
  }

  /* Suchtreffer Speicher (Familie + Größe). */
  function setzeSpeicherTreffer(zustand, daten, familieId, groesse) {
    var fam = null;
    (daten.speicher || []).forEach(function (f) { if (f.id === familieId) fam = f; });
    if (!fam) return false;
    zustand.spHersteller = fam.hersteller;
    zustand.spFamilie = fam.id;
    zustand.spGroesse = groesse;
    return true;
  }

  function leereWr(zustand) {
    zustand.wrVariante = null; zustand.wrFamilie = null; zustand.wrHersteller = null;
  }

  function leereSpeicher(zustand) {
    zustand.spFamilie = null; zustand.spGroesse = null; zustand.spHersteller = null;
  }

  /* Die drei Auswahlfelder: Jede Wahl weiter oben setzt alles darunter
   * zurück — eine Modellreihe eines anderen Herstellers wäre sonst still
   * stehengeblieben. */
  function setzeWrHersteller(zustand, wert) {
    zustand.wrHersteller = wert; zustand.wrFamilie = null; zustand.wrVariante = null;
  }

  function setzeWrFamilie(zustand, wert) {
    zustand.wrFamilie = wert; zustand.wrVariante = null;
  }

  function setzeWrVariante(zustand, wert) {
    zustand.wrVariante = wert;
  }

  function setzeSpHersteller(zustand, wert) {
    zustand.spHersteller = wert; zustand.spFamilie = null; zustand.spGroesse = null;
  }

  function setzeSpFamilie(zustand, wert) {
    zustand.spFamilie = wert; zustand.spGroesse = null;
  }

  function setzeSpGroesse(zustand, wert) {
    zustand.spGroesse = wert;
  }

  /*
   * Wann die Auswahl reicht: Erweiterung braucht BEIDE Geräte. Die Frage
   * lautet nicht „welche Größen gibt es", sondern „welche größere Stufe ist
   * an meinem Wechselrichter freigegeben" — ohne ihn gäbe es darauf keine
   * belegbare Antwort.
   */
  function auswahlVollstaendig(zustand) {
    var wr = !!zustand.wrVariante;
    var sp = !!(zustand.spFamilie && zustand.spGroesse);
    if (zustand.aufgabe === 'speicher_finden') return wr;
    if (zustand.aufgabe === 'wr_finden') return sp;
    return sp && wr;
  }

  /* Vergleichsauswahl mit Obergrenze. false = abgelehnt (Limit erreicht),
   * das Häkchen der UI springt dann zurück. */
  function vergleichWechsel(zustand, id, an, maximum) {
    if (an && zustand.vergleich.length >= maximum) return false;
    zustand.vergleich = an
      ? zustand.vergleich.concat([id])
      : zustand.vergleich.filter(function (x) { return x !== id; });
    return true;
  }

  return {
    neuerZustand: neuerZustand,
    wechsleAufgabe: wechsleAufgabe,
    oeffneAuswahl: oeffneAuswahl,
    setzeWrTreffer: setzeWrTreffer,
    setzeSpeicherTreffer: setzeSpeicherTreffer,
    leereWr: leereWr,
    leereSpeicher: leereSpeicher,
    setzeWrHersteller: setzeWrHersteller,
    setzeWrFamilie: setzeWrFamilie,
    setzeWrVariante: setzeWrVariante,
    setzeSpHersteller: setzeSpHersteller,
    setzeSpFamilie: setzeSpFamilie,
    setzeSpGroesse: setzeSpGroesse,
    auswahlVollstaendig: auswahlVollstaendig,
    vergleichWechsel: vergleichWechsel,
  };
});
